import type { ReactElement } from 'react';
import { cn } from '@luacentrix/ui';

export const BRAND_LOGO_SRC = '/brand/logo.png';

export const BRAND_LOGO_ALT = 'LuaCentrix by Centrix Hub';

export const BRAND_LOGO_INTRINSIC_SIZE = 512;

const brandLogoEdges = {
  sm: 24,
  md: 32,
  lg: 40,
} as const;

export type BrandLogoSize = keyof typeof brandLogoEdges;

export interface BrandLogoProps {
  size?: BrandLogoSize;
  className?: string | undefined;
}

export function BrandLogo({ size = 'md', className }: BrandLogoProps): ReactElement {
  const edge = brandLogoEdges[size];
  return (
    <img
      className={cn('brand-logo', `brand-logo--${size}`, className)}
      src={BRAND_LOGO_SRC}
      alt={BRAND_LOGO_ALT}
      width={edge}
      height={edge}
      decoding="async"
      data-brand-logo-size={size}
      data-brand-logo-edge={String(edge)}
    />
  );
}
